import axios from "./services/axios/backendAxios";

export default async function defaultQueryFunction({ queryKey }) {
  const url = Array.isArray(queryKey) ? queryKey[0] : queryKey;
  const { data } = await axios.get(url);
  return data;
}
